/* eslint-disable import/prefer-default-export */
export const rowProps = {
  type: 'flex',
  gutter: 16,
};
